/* eslint-disable array-callback-return */
import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components/macro';
import { NavLink, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import * as Yup from 'yup';
import _ from 'lodash';
import {
  CardContent,
  Grid,
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  Paper as MuiPaper,
  TextField,
  Typography,
  FormControl,
  Button,
  Checkbox,
  Snackbar,
  Alert,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Collapse,
  Box,
  Autocomplete,
} from '@mui/material';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { spacing } from '@mui/system';
import axios from '../../CustomAxios';
import { Formik } from 'formik';
import Loading from '../components/Loading';
import swal from 'sweetalert';
import { connect } from 'react-redux';
import { DateTimePicker } from '@mui/lab';

const Card = styled(MuiCard)(spacing);
const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);
const Paper = styled(MuiPaper)(spacing);

function FormDetails({ apCompanies, missingPermissions, companies }) {
  const [down, setDown] = useState(false);
  const [err, setErr] = useState('');
  const [success, setSuccess] = useState(false);
  const [rows, setRows] = useState([]);
  const [selectedJobs, setSelectedJobs] = useState({});
  const [deliveryCharges, setDeliveryCharges] = useState({});
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const snackRef = useRef(null);
  const [state, setState] = useState({
    open: false,
    vertical: 'top',
    horizontal: 'center',
  });
  const { vertical, horizontal, open } = state;
  const handleClick = (newState) => () => {
    setState({ open: true, ...newState });
  };
  const handleClose = () => {
    setState({ ...state, open: false });
  };

  const getJobs = async (id, ap) => {
    try {
      const authData = JSON.parse(localStorage.getItem('AuthData'));
      const config = {
        headers: {
          Authorization: 'Bearer ' + authData.access_token,
        },
      };
      const { data } = await axios.get(
        `/api/v1/${authData?.type}/jobs?current_status=delivery&customer_company_id=${id}&challan_created=NO&ap_company_id=${ap}&populate_plate=YES&limit=1000`,
        config
      );
      let rows = [];
      if (data.success) {
        data.data.data.map((row) => {
          rows.push(
            createData(
              row._id,
              row.job_id,
              row.name,
              `${row.delivery?.address_line_one}, ${row.delivery?.address_line_two}, ${row.delivery?.city}, ${row.delivery?.state}, ${row.delivery?.pincode}, India`,
              row.required_date,
              row.received_date,
              row
            )
          );
        });
        if (id && ap) {
          setRows(rows);
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  const submit = async (values, resetForm) => {
    try {
      let jobs = [];
      Object.keys(selectedJobs).map((job) => {
        if (selectedJobs[job]) {
          jobs.push(job);
        }
      });
      if (!jobs.length) {
        setErr('Select at least one job');
        snackRef.current.click();
        return;
      }

      // Build delivery charges array
      const jobDeliveryCharges = jobs.map(jobId => ({
        job: jobId,
        delivery_charge: deliveryCharges[jobId] || 0
      }));

      // Validate that every selected job has a non-negative delivery charge
      const invalidCharge = jobDeliveryCharges.find(c => c.delivery_charge < 0);
      if (invalidCharge) {
        setErr('Delivery charge cannot be negative');
        snackRef.current.click();
        return;
      }

      setLoader(true);
      const userData = JSON.parse(localStorage.getItem('AuthData'));
      const config = {
        headers: {
          Authorization: 'Bearer ' + userData.access_token,
        },
      };
      const { data } = await axios.post(
        `/api/v1/${userData.type}/challan`,
        {
          name: values.name,
          description: values.description,
          ap_company: values.ap_company,
          customer_company: values.customer_company,
          jobs,
          challan_date: new Date(values.challan_date).toISOString(),
          job_delivery_charges: jobDeliveryCharges,
        },
        config
      );
      if (data.success) {
        setLoader(false);
        setSuccess(true);
        setErr('');
        setSelectedJobs({});
        setDeliveryCharges({});
        snackRef.current.click();
        resetForm({ values: '' });
        setRows([]);
        navigate('/dashboard/challan/', {
          state: { success: true, message: 'Challan Created Successfully' },
        });
      }
    } catch (e) {
      setLoader(false);
      if (e.response.data.error) {
        setErr(e.response.data.error);
      } else {
        setErr('Server Error');
      }
      snackRef.current.click();
    }
  };

  useEffect(() => {}, [err]);
  useEffect(() => {}, [selectedJobs]);

  function createData(id, job_id, name, delivery, required_date, recieved_date, data) {
    return { id, job_id, name, delivery, required_date, recieved_date, data };
  }

  function isAnyJobSelected() {
    let jobs = [];
    Object.keys(selectedJobs).map((job) => {
      if (selectedJobs[job]) {
        jobs.push(job);
      }
    });
    return jobs.length > 0;
  }

  function checkSelectedDateIsInBetween(selectedDateInput) {
    let jobCreationsDates = [];
    Object.keys(selectedJobs).forEach((job_item) => {
      if (selectedJobs[job_item]) {
        const currentJobItem = rows.find((it) => it.id === job_item);
        jobCreationsDates.push(new Date(currentJobItem?.data?.received_date));
      }
    });
    jobCreationsDates.sort();

    const dateCheck = new Date(selectedDateInput);
    const dateFrom = new Date(jobCreationsDates[0]);
    const latestJobCreationDate = new Date(jobCreationsDates[jobCreationsDates.length - 1]);
    const dateTo = new Date(
      latestJobCreationDate.setFullYear(latestJobCreationDate.getFullYear() + 1)
    );

    return dateCheck.getTime() <= dateTo.getTime() && dateCheck.getTime() >= dateFrom.getTime();
  }

  function showErrorAlert(message) {
    setErr(message);
    snackRef.current.click();
  }

  return (
    <>
      <Formik
        initialValues={{
          name: '',
          description: '',
          ap_company: '',
          customer_company: '',
          submit: false,
          challan_date: '',
        }}
        validationSchema={Yup.object().shape({
          name: Yup.string().required('Challan Name is required'),
          description: Yup.string().required('Description is required'),
          ap_company: Yup.string().required('AP Company is required'),
          customer_company: Yup.string().required('Customer Company is required'),
          challan_date: Yup.string().required('Challan Date is required'),
        })}
        onSubmit={async (values, { setErrors, setStatus, setSubmitting, resetForm }) => {
          try {
            submit(values, resetForm);
          } catch (error) {
            const message = error.message || 'Something went wrong';
            setStatus({ success: false });
            setErrors({ submit: message });
            setSubmitting(false);
          }
        }}
      >
        {({
          errors,
          setFieldValue,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          touched,
          values,
        }) => (
          <form noValidate onSubmit={handleSubmit} autoComplete='off'>
            <Button
              ref={snackRef}
              style={{ display: 'none' }}
              onClick={handleClick({ vertical: 'top', horizontal: 'center' })}
            >
              Click
            </Button>
            <Snackbar
              anchorOrigin={{ vertical, horizontal }}
              open={open}
              onClose={handleClose}
              key={vertical + horizontal}
            >
              {err ? (
                <Alert mt={2} mb={4} severity='error'>
                  {err}
                </Alert>
              ) : success ? (
                <Alert mt={2} mb={4} severity='success'>
                  Challan created Successfully
                </Alert>
              ) : null}
            </Snackbar>
            {!loader ? (
              <Card mb={6}>
                <CardContent>
                  <Paper elevation={3} style={{ padding: '2%' }}>
                    <Grid container spacing={5}>
                      <Grid item xs={12} lg={12} md={12}>
                        <Typography variant='h6' gutterBottom>
                          Create Challan
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={12} lg={6}>
                        <TextField
                          fullWidth
                          name='name'
                          value={values.name}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={Boolean(touched.name && errors.name)}
                          id='search-field'
                          label='Challan Name'
                          helperText={touched.name && errors.name}
                        />
                      </Grid>
                      <Grid item xs={12} md={12} lg={6}>
                        <FormControl
                          fullWidth
                          error={Boolean(touched.customer_company && errors.customer_company)}
                        >
                          <DateTimePicker
                            name='challan_date'
                            renderInput={(props) => (
                              <TextField
                                {...props}
                                error={touched.challan_date && errors.challan_date}
                              />
                            )}
                            label='Challan Date'
                            value={values.challan_date || null}
                            onChange={(newValue) => {
                              if (!isAnyJobSelected()) {
                                showErrorAlert('Please select a Job first');
                                setFieldValue('challan_date', '');
                                return;
                              }
                              if (!checkSelectedDateIsInBetween(newValue)) {
                                showErrorAlert(
                                  'Please select a date between the oldest jobs date and one year from latest job date'
                                );
                                setFieldValue('challan_date', '');
                                return;
                              }
                              let selectedDate = newValue;
                              var month = ('0' + parseInt(selectedDate?.getMonth() + 1)).slice(-2);
                              var day = ('0' + parseInt(selectedDate?.getDate())).slice(-2);
                              var hour = parseInt(selectedDate.getHours());
                              var minute = parseInt(selectedDate.getMinutes());
                              let date =
                                selectedDate?.getFullYear() +
                                '-' +
                                month +
                                '-' +
                                day +
                                ':' +
                                hour +
                                ':' +
                                minute;
                              setFieldValue('challan_date', date);
                            }}
                            onBlur={handleBlur}
                          />
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} md={12} lg={12}>
                        <TextField
                          fullWidth
                          name='description'
                          value={values.description}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={Boolean(touched.description && errors.description)}
                          id='search-field'
                          label='Description'
                          helperText={touched.description && errors.description}
                          multiline
                        />
                      </Grid>

                      <Grid item xs={12} md={12} lg={6}>
                        <FormControl
                          fullWidth
                          error={Boolean(touched.ap_company && errors.ap_company)}
                        >
                          <Autocomplete
                            id='combo-box-demo'
                            options={apCompanies}
                            value={values?.ap_company?.name}
                            onChange={(event, newValue) => {
                              setFieldValue('ap_company', newValue?._id || '');
                              getJobs(values?.customer_company, newValue?._id);
                              setSelectedJobs({});
                              setDeliveryCharges({});
                            }}
                            inputValue={values?.ap_company?.name}
                            onBlur={handleBlur}
                            getOptionLabel={(option) => option?.name}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                error={Boolean(touched.ap_company && errors.ap_company)}
                                helperText={touched.ap_company && errors.ap_company}
                                label='AP Company'
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={12} lg={6}>
                        <FormControl
                          fullWidth
                          error={Boolean(touched.customer_company && errors.customer_company)}
                        >
                          <Autocomplete
                            id='combo-box-demo'
                            options={companies}
                            value={values?.customer_company?.name}
                            onChange={(event, newValue) => {
                              setFieldValue('customer_company', newValue?._id || '');
                              if (newValue !== null) {
                                getJobs(newValue?._id, values?.ap_company);
                              }
                              setSelectedJobs({});
                              setDeliveryCharges({});
                            }}
                            inputValue={values?.customer_company?.name}
                            onBlur={handleBlur}
                            getOptionLabel={(option) => option?.name}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                error={Boolean(touched.customer_company && errors.customer_company)}
                                helperText={touched.customer_company && errors.customer_company}
                                label='Customer Company'
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} lg={12} md={12}></Grid>
                      <Grid item xs={12} lg={12} md={12}>
                        <Typography variant='h6'>Select Jobs For Challan</Typography>
                        <TableContainer component={Paper}>
                          <Table sx={{ minWidth: 650 }} aria-label='simple table'>
                            <TableHead>
                              <TableRow>
                                <TableCell padding='checkbox' />
                                <TableCell align='left'>Job Id</TableCell>
                                <TableCell align='left'>Job Name</TableCell>
                                <TableCell align='left'>Delivery Address</TableCell>
                                <TableCell align='left'>Received Date</TableCell>
                                <TableCell align='left'>Delivery Date</TableCell>
                                <TableCell align='left'>Delivery Charge (₹)</TableCell>
                                <TableCell padding='checkbox' />
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {rows.map((row, i) => {
                                return (
                                  <React.Fragment key={row.id}>
                                    <TableRow
                                      sx={{
                                        '&:last-child td, &:last-child th': { border: 0 },
                                      }}
                                    >
                                      <TableCell padding='checkbox'>
                                        <Checkbox
                                          color='primary'
                                          checked={selectedJobs[row.id] || false}
                                          name={row.id}
                                          onChange={(e) => {
                                            setSelectedJobs({
                                              ...selectedJobs,
                                              [e.target.name]: e.target.checked,
                                            });
                                            // Initialize delivery charge to 0 if newly selected
                                            if (e.target.checked && !deliveryCharges[row.id]) {
                                              setDeliveryCharges(prev => ({
                                                ...prev,
                                                [row.id]: 0
                                              }));
                                            }
                                          }}
                                        />
                                      </TableCell>
                                      <TableCell component='th' scope='row'>
                                        {row.job_id}
                                      </TableCell>
                                      <TableCell align='left'>{row.name}</TableCell>
                                      <TableCell align='left'>{row.delivery}</TableCell>
                                      <TableCell align='left'>
                                        {new Date(row.recieved_date).toLocaleString()}
                                      </TableCell>
                                      <TableCell align='left'>
                                        {new Date(row.required_date).toLocaleString()}
                                      </TableCell>
                                      <TableCell align='left'>
                                        <TextField
                                          type='number'
                                          size='small'
                                          disabled={!selectedJobs[row.id]}
                                          value={deliveryCharges[row.id] ?? ''}
                                          onChange={(e) => {
                                            const val = parseFloat(e.target.value);
                                            setDeliveryCharges({
                                              ...deliveryCharges,
                                              [row.id]: isNaN(val) ? 0 : val,
                                            });
                                          }}
                                          InputProps={{ inputProps: { min: 0, step: 0.01 } }}
                                          style={{ width: 100 }}
                                        />
                                      </TableCell>
                                      <TableCell>
                                        <IconButton
                                          aria-label='expand row'
                                          size='small'
                                          onClick={() => {
                                            if (down === i) setDown(-1);
                                            else setDown(i);
                                          }}
                                        >
                                          {down === i ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                                        </IconButton>
                                      </TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell
                                        style={{ paddingBottom: 0, paddingTop: 0 }}
                                        colSpan={7}
                                      >
                                        <Collapse in={down === i} timeout='auto' unmountOnExit>
                                          <Box sx={{ margin: 1, padding: 4 }}>
                                            <Typography variant='h6' gutterBottom component='div'>
                                              Job Plate Details
                                            </Typography>
                                            <Table size='small' aria-label='jobs'>
                                              <TableHead>
                                                <TableRow>
                                                  <TableCell align='left'>Size</TableCell>
                                                  <TableCell align='left'>Quantity</TableCell>
                                                  <TableCell align='left'>Company</TableCell>
                                                  <TableCell align='left'>Brand</TableCell>
                                                  <TableCell align='left'>Technology</TableCell>
                                                </TableRow>
                                              </TableHead>
                                              <TableBody>
                                                {row.data.plates.map((plate) => (
                                                  <TableRow key={plate.plate_id}>
                                                    <TableCell align='left'>
                                                      {plate?.plate_details?.height}*
                                                      {plate?.plate_details?.width}*
                                                      {plate?.plate_details?.thickness}
                                                    </TableCell>
                                                    <TableCell align='left'>
                                                      {plate?.quantity}
                                                    </TableCell>
                                                    <TableCell align='left'>
                                                      {plate?.plate_details?.company}
                                                    </TableCell>
                                                    <TableCell align='left'>
                                                      {plate?.plate_details?.brand?.name}
                                                    </TableCell>
                                                    <TableCell align='left'>
                                                      {plate?.plate_details?.technology?.name}
                                                    </TableCell>
                                                  </TableRow>
                                                ))}
                                              </TableBody>
                                            </Table>
                                          </Box>
                                        </Collapse>
                                      </TableCell>
                                    </TableRow>
                                  </React.Fragment>
                                );
                              })}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Grid>

                      <Grid item xs={12} md={12} lg={12}>
                        <Button
                          type='submit'
                          style={{ textAlign: 'center', margin: '10px' }}
                          mr={2}
                          variant='contained'
                          color='primary'
                          disabled={isSubmitting || missingPermissions.length > 0}
                        >
                          Create Challan
                        </Button>
                      </Grid>
                    </Grid>
                  </Paper>
                </CardContent>
              </Card>
            ) : (
              <Loading />
            )}
          </form>
        )}
      </Formik>
    </>
  );
}

const getUserCompanies = async (setCompanies, setApCompanies, setLoader) => {
  try {
    const userData = JSON.parse(localStorage.getItem('AuthData'));
    const config = {
      headers: {
        Authorization: 'Bearer ' + userData.access_token,
      },
    };
    const apCompany = await axios.get(`/api/v1/${userData?.type}/ap_company`, config);
    if (apCompany.data.success) {
      setApCompanies(apCompany.data.data.data);
    }
    const { data } = await axios.get(`/api/v1/${userData.type}/customer_company?limit=1000`, config);
    if (data.success) {
      setCompanies(data.data.data);
    }
    setLoader(false);
  } catch (e) {
    setLoader(false);
    console.log(e);
  }
};

function CreateChalan({ auths }) {
  const [companies, setCompanies] = useState([]);
  const [loader, setLoader] = useState(true);
  const [apCompanies, setApCompanies] = useState([]);

  const [missingPermissions, setMissingPermissions] = useState([]);
  let requiredPermissions = ['view_ap_company_list', 'view_customer_company_list'];

  useEffect(() => {
    if (auths?.user) {
      let userPermissions = auths.user?.role?.permissions;
      if (userPermissions) {
        const missing = _.difference(requiredPermissions, userPermissions);
        setMissingPermissions(missing);
        if (missing.length > 0) {
          swal(
            '',
            `You are unauthorized to complete this action because you do not have the following permissions

            ${_.toUpper(missing.join(', ').replace(/_/g, ' '))}
            `,
            'error'
          );
        }
      }
    }
    // eslint-disable-next-line
  }, [auths.user]);

  useEffect(() => {
    getUserCompanies(setCompanies, setApCompanies, setLoader);
  }, []);
  if (!loader) {
    return (
      <React.Fragment>
        <Helmet title='Alpha Plus' />
        <Grid justifyContent='space-between' alignItems='center' container spacing={10} mb={4}>
          <Grid item>
            <Typography
              variant='h4'
              gutterBottom
              display='inline'
              sx={{ fontWeight: 600 }}
              color='primary'
            >
              CREATE CHALLAN
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label='Breadcrumb' mt={2}>
              <Link component={NavLink} to='/dashboard/tasks'>
                Dashboard
              </Link>
              <Link component={NavLink} to='/dashboard/challan'>
                All Challans
              </Link>
              <Typography>Create Challan</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <Grid container spacing={6}>
          <Grid item xs={12}>
            <FormDetails
              missingPermissions={missingPermissions}
              apCompanies={apCompanies}
              companies={companies}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  } else {
    return <Loading />;
  }
}

const mapStateToProps = (state) => ({
  auths: state.auths,
});

export default connect(mapStateToProps, null)(CreateChalan);